import React from "react";
import Footer from "../Components/Footer";
import MaintenanceNotice from "../Components/MaintenanceNotice";
import NavBar from "../Components/NavBar";


const Home = () => {
  return (
    <>
                 <MaintenanceNotice />

       <div className="pages" >

        <NavBar />
      <div id="home">

<section>
<div id="who-are-we" className="light-background">
          <h1>Our Story</h1>

          <p className="p-text">
            Take a look at North California before the rise of Silicon Valley
            and what it is today. How many jobs have been created there? In the
            region, how many infrastructure projects have been completed? How
            have universities and research centers benefited from the rise? Take
            a look at Africa today. Underdeveloped cities, high levels of
            poverty and unemployment, and unreliable public transportation. The
            Vision of Beast-O is to bring a revolution to Africa that has the
            same impact as the rise of the valley in North California. Startups
            and informal traders play a critical role in the growth of the
            economy. They must maximize their revenue turnover in order to
            sustain this growth. By using technology solutions that assist with
            financial planning, marketing, branding, as well as other business
            functions, we help startups and informal traders to grow their
            sales. All these Silicon Valleys were once small startups that grew
            into large corporations, so with us African startups are going to
            grow big soon.
          </p>
        </div>
        <div id="what-have-we-done" className="light-background">
          <h1>Our Achievements</h1>
        </div>
        <div id="our-future" className="light-background">
          <h1>Our Future</h1>
          <p className="p-text">
            Our future is bright like the stars of the Sky. By 2030 we estimate
            to have:
          </p>
          <ul>
            <li className="facts-list">
              Helped 10 000+ informal traders to upgrade their businesses into
              formal sector by providing them IT Solutions that increase
              profitability
            </li>
            <li className="facts-list">
              Own the best E-Commerce platform in Zimbabwe
            </li>
            <li className="facts-list">
              Employed 1000+ people across Zimbabwe
            </li>
       
            <li className="facts-list">Spent $50 000+ in community projects</li>
          </ul>
        </div>

</section>
<section>

</section>


       </div>
       
        
      </div>
      <Footer />
    </>
  );
};
export default Home;
